import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { landingColors } from "../../assets/theme/landingTheme";
import { PRODUCT_NAME_TITLE, PRODUCT_TAGLINE } from "../../constants/config";

const Footer = ({ variant = "desktop" }) => {
  const isTablet = variant === "tablet";

  return (
    <Box
      data-cy="landing-footer"
      sx={{
        padding: { xs: "10px 0", md: isTablet ? "12px 0" : "14px 0" },
        textAlign: "center",
        position: "relative",
        mt: 0, // Ensure no extra margin on top
        paddingBottom: 1.5, // Ensure no extra padding at the bottom
        height: "auto", // Make sure the footer height is flexible
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          color: landingColors.deepNavy,
          fontSize: { xs: "0.9rem", md: isTablet ? "0.9rem" : "0.94rem" },
          mb: 0.75,
        }}
      >
        {PRODUCT_NAME_TITLE} © {new Date().getFullYear()} - {PRODUCT_TAGLINE}
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "center", gap: { xs: 1.6, md: 2.25 }, mt: 0.25, flexWrap: "wrap" }}>
        <Link
          href="/how-it-works"
          sx={{
            color: landingColors.deepNavy,
            textDecoration: "none",
            "&:hover": { color: landingColors.brandAccent },
          }}
        >
          How it works
        </Link>
        <Link
          href="/privacy-policy"
          sx={{
            color: landingColors.deepNavy,
            textDecoration: "none",
            "&:hover": { color: landingColors.brandAccent },
          }}
        >
          Privacy Policy
        </Link>
        <Link
          href="/cookie-policy"
          sx={{
            color: landingColors.deepNavy,
            textDecoration: "none",
            "&:hover": { color: landingColors.brandAccent },
          }}
        >
          Cookie Policy
        </Link>
        <Link
          href="/terms-of-service"
          sx={{
            color: landingColors.deepNavy,
            textDecoration: "none",
            "&:hover": { color: landingColors.brandAccent },
          }}
        >
          Terms of Service
        </Link>
        <Link
          href="/contact-us"
          sx={{
            color: landingColors.deepNavy,
            textDecoration: "none",
            "&:hover": { color: landingColors.brandAccent },
          }}
        >
          Connect with me
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
